import { FeatureToggleType } from '../enum/FeatureToggleType'
import { create } from 'zustand'

export declare interface IFeatureToggleStore {
  toggleList: Map<FeatureToggleType, boolean>
}

export const useFeatureToggleStore = create<IFeatureToggleStore>(() => ({
  toggleList: new Map(),
}))
